import React from 'react';
import theme from './FeatureTable.module.scss';
import { createDataTable } from 'components/DataTable';
import { classnames, CustomLink, DataTableState, SlideToggle } from '@ygtechnologies/bygr-frontend-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons';
import { FeatureToggleWithDefinitionDTO } from 'services/featureToggle';

const DataTable = createDataTable<FeatureToggleWithDefinitionDTO>();
export interface FeatureTableProps {
    data: FeatureToggleWithDefinitionDTO[];
    setTableState: React.Dispatch<React.SetStateAction<DataTableState<FeatureToggleWithDefinitionDTO>>>;
    tableState: DataTableState<FeatureToggleWithDefinitionDTO>;
    handleFeatureToggle: (checked: boolean, feature: string) => void;
    includeProfileColumn?: boolean;
}

export const FeatureTable: React.FC<FeatureTableProps> = ({
    data,
    setTableState,
    tableState,
    handleFeatureToggle,
    includeProfileColumn = false,
}) => {
    return (
        <DataTable
            onStateChange={setTableState}
            state={tableState}
            totalItemCount={data.length}
            hasPagination={true}
            className="table style-3"
            data={data}>
            <DataTable.Column
                header="Feature"
                field="featureName"
                renderer={({ row }) => (
                    <div className={theme.featureColumn}>
                        <SlideToggle
                            className={classnames({ [theme.disabled]: includeProfileColumn && row.profileToggled })}
                            disabled={includeProfileColumn && row.profileToggled}
                            onChange={(e) => handleFeatureToggle(e.target.checked, row.featureName)}
                            checked={row.toggled}></SlideToggle>
                        {row.featureName}
                        <CustomLink to={`/features/${row.featureName}`}>
                            <FontAwesomeIcon icon={faExternalLink} />
                        </CustomLink>
                    </div>
                )}
            />
            {includeProfileColumn ? (
                <DataTable.Column
                    header="Is enabled by Profile"
                    field="profileToggled"
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                />
            ) : (
                <></>
            )}

            <DataTable.Column header="Is paid feature" field="isPaid" renderer={(x) => (x.value ? 'Yes' : 'No')} />
            <DataTable.Column header="Info" field="information" />
            <DataTable.Column header="Is Experimental" field="isExperimental" renderer={(x) => (x.value ? 'Yes' : 'No')} />
            <DataTable.Column
                header="Is enabled/disabled for all"
                field="toggleForAll"
                renderer={(x) => (x.value === true ? 'Enabled' : x.value === false ? 'Disabled' : 'Not set')}
            />
        </DataTable>
    );
};